import { AdminUsersView } from "@/admin/users/AdminUsersView.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_simple/admin_users")({
    component: AdminUsersView,
});
